export const BONUS_TABLE_PROPERTIES = {
    HEADERS: ['BONUS NAME', 'DATE', 'BONUS PRIZE', 'AWARDED BY', ''],
    NO_SORT: [2, 3, 4, 5],
    COLUMN_WIDTH: ['25%', '20%', '15%', '20%', '25%'],
    SORT_KEY: ['name', 'launchDate', 'amount', '', ''],
};
